import { z } from '@harvestiq/zod';
import { RmaLrpTypeCodes, RmaLrpCommodityCodes } from '@harvestiq/constants';

export const lrpCommodityCodeTypeCodePairSchema = z.object({
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  typeCode: z.nativeEnum(RmaLrpTypeCodes),
});

export type LrpCommodityCodeTypeCodePair = z.infer<
  typeof lrpCommodityCodeTypeCodePairSchema
>;
